module.exports = __webpack_public_path__ + "static/media/Molex.eec6c1b8.svg";